import { Entidad } from "../Entidad";

// #region Movimientos

export interface IFinanzaEdoCtaMovimiento {
    /** Descripción del cargo */
    Cargo: string;
    Categoria: Entidad.CFinanzaCategoriaMovimiento;
    CicloEscolar: number;
    Detalles: IFinanzaEdoCtaMovimientoDetalle[];
    FechaAplicacion: string;
    FechaFin: string;
    FechaInicio: string;
    FechaMorosidad: string;
    FechaVencimiento: string;
    Id: number;
    IdAgrupador: number;
    /** Id de asignación (cargo | descuento) */
    IdAsignacionCargo: number;
    /** Id de cargo clon  */
    IdCargo: number;
    Periodicidad: Entidad.CFinanzaCargoPeriodicidadCargos;
    Recargo: number;
    Saldo: number;
    /** Uso: ?? */
    TipoInteres: Entidad.CFinanzaCargoTipoInteres;
    /** No tiene por qué ser diferente de Monto */
    TipoValor: Entidad.CFinanzaCargoTipoValor;
    Valor: number;
}

export interface IFinanzaEdoCtaMovimientoDetalle {
    /** Descripción del dato si aplica */
    Cargo: string;
    Categoria: Entidad.CFinanzaCategoriaMovimiento;
    /** Cuando no aplica es `null` */
    FechaAplicacion: string | null;
    FechaMorosidad: string;
    FechaRegistro: string;
    Id: number;
    IdAsignacionCargo: number;
    IdCargo: number;
    IdFacturaFolio: number;
    IdMetodoPago: number;
    /** @deprecated NO SE USA */
    Periodicidad: Entidad.CFinanzaCargoPeriodicidadCargos;
    Recargo: number;
    Saldo: number;
    TipoInteres: Entidad.CFinanzaCargoTipoInteres;
    TipoValor: Entidad.CFinanzaCargoTipoValor;
    /** Último bloque del código UUID */
    UUID: string;
    Valor: number;

    // >> Propiedades cuando `Categoria` es PagoCompleto o PagoParcial
    /** != `undefined`: `Categoria` == PagoCompleto | PagoParcial
     * @example: "OVEJA25-000001"
    */
    FolioPago?: string | undefined;
    /**
     * >0: Usuario Tutor
     * <0: Usuario Administrativo
     * != `undefined`: `Categoria` == PagoCompleto | PagoParcial */
    IdUsuarioCreo?: number | undefined;

    // >> Propiedades cuando `Categoria` es Comision
    /** != undefined: `Categoria` == Comision */
    IdComision?: number;
    /** != undefined: `Categoria` == Comision */
    TipoValorComisionPlantilla?: Entidad.CFinanzaCargoTipoValor;
    /** != undefined: `Categoria` == Comision
     *
     * Relacionado con `TipoValorComisionPlantilla`,
     * si es Porcentaje(2) multiplicar por 100 */
    ValorComisionPlantilla?: number;
}

// #region Pago en linea

export enum CFinanzaPagoEnLineaEstado {
    Pendiente = 1,
    Pagado = 2,
}

export enum CFinanzaPagoEnLineaFormaPago {
    Tarjeta = 1,
    TransferenciaBancaria = 2,
    Efectivo = 3
}

export interface IFinanzaFolioPagoEnLinea {
    EstadoPago: CFinanzaPagoEnLineaEstado;
    FechaVigencia: string | null;
    FechaCreacion: string;
    /** @example "OVEJA25-000001" */
    Folio: string;
    FormaPago: CFinanzaPagoEnLineaFormaPago;
    Id: number;
    IdsMovimientos: number[];
    Montos: number[];
    TiposPago: Entidad.CTipoPago[];
    /**
     * >0: Id Tutor
     * <0: ??
     */
    IdUsuarioCreo: number;
    RequiereFactura: boolean;
    /** Si no requiere factura es `null` */
    IdFacturaFolio: number | null;
}
